import styled from "styled-components";
import { Button } from 'antd'


export const TitleImgStyle = styled.div`
    /* background-image: url(https://images.unsplash.com/photo-1526887520775-4b14b8aed897?ixlib=rb-1.2.1&q=70&fm=jpg&crop=entropy&cs=tinysrgb&w=768&fit=max&ixid=eyJhcHBfaWQiOjExNzczfQ); */
    /* height: 600px;
    width: 100%; */
    .img{
        width: 100%;
    }
`;
export const TitleStyle = styled.div`
    padding: 135px 80px;
    text-align:right;
`;
export const TitleHeadStyle = styled.div`
    background-color: #DABAAD;
    .right{
        padding: 0;
    }
`;
